<div class="dialog-container">
    <h4 mat-dialog-title>Time Entries (Weekly)</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <div *ngIf="data.employeeTimeSheet" class="p-0">
            <div class="table-scroll-wrapper">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

                <ng-container matColumnDef="timeSheetDate">
                    <th class="text-primary" mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.timeSheetDate | date: 'MM/dd/yyyy' }}</td>
                </ng-container>

                <ng-container matColumnDef="branch">
                    <th class="text-primary" mat-header-cell *matHeaderCellDef mat-sort-header>Branch</th>
                    <td mat-cell *matCellDef="let employee">{{ employee.branch }}</td>
                </ng-container>

                <ng-container matColumnDef="ramp_Time1">
                    <th class="text-primary" mat-header-cell *matHeaderCellDef mat-sort-header>Time In</th>
                    <td mat-cell *matCellDef="let employee">{{ formatTime(employee.ramp_Time1) }}</td>
                </ng-container>

                <ng-container matColumnDef="note1">
                    <th class="text-primary" mat-header-cell *matHeaderCellDef>Time In Note</th>
                    <td mat-cell *matCellDef="let employee; let i = index" class="text-muted note-cell">
                        <span *ngIf="!expandedNotes['note1_' + i]; else fullNote1">
                            {{ employee.note1 ? (employee.note1.length > 40 ? (employee.note1 | slice:0:40) + '...' :
                            employee.note1) : 'N/A' }}
                            <button *ngIf="employee.note1 && employee.note1.length > 40" class="see-more-btn"
                                (click)="toggleNote('note1_' + i)">
                                see more
                            </button>
                        </span>
                        <ng-template #fullNote1>
                            {{ employee.note1 }}
                            <button class="see-more-btn" (click)="toggleNote('note1_' + i)">see less</button>
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ramp_Time2">
                    <th class="text-primary" mat-header-cell *matHeaderCellDef mat-sort-header>Time Out</th>
                    <td mat-cell *matCellDef="let employee">{{ formatTime(employee.ramp_Time2) }}</td>
                </ng-container>

                <ng-container matColumnDef="note2">
                    <th class="text-primary" mat-header-cell *matHeaderCellDef>Time Out Note</th>
                    <td mat-cell *matCellDef="let employee; let i = index" class="text-muted note-cell">
                        <span *ngIf="!expandedNotes['note2_' + i]; else fullNote2">
                            {{ employee.note2 ? (employee.note2.length > 40 ? (employee.note2 | slice:0:40) + '...' :
                            employee.note2) : 'N/A' }}
                            <button *ngIf="employee.note2 && employee.note2.length > 40" class="see-more-btn"
                                (click)="toggleNote('note2_' + i)">
                                see more
                            </button>
                        </span>
                        <ng-template #fullNote2>
                            {{ employee.note2 }}
                            <button class="see-more-btn" (click)="toggleNote('note2_' + i)">see less</button>
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="submitted">
                    <th class="text-primary" mat-header-cell *matHeaderCellDef>Submitted</th>
                    <td mat-cell *matCellDef="let employee" class="text-muted">{{ employee.submitted ? 'Complete' :
                        'Pending' }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            </div>

            <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
    </div>
</div>